/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {OrderBudgetModalComponent} from './order-budget-modal.component';

export interface OrderBudgetModalOptions {
  modelObject: any;
  moneyCurrency: any;
  objTranslation: string;
}

@Injectable({providedIn: 'root'})
export class OrderBudgetModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: OrderBudgetModalOptions): Promise<{obj?: any}> {
    return new Promise((resolve) => {
      let settled = false;
      const complete = (result: {obj?: any}) => {
        if (settled) {
          return;
        }
        settled = true;
        resolve(result);
      };
      const modalRef = this.angularModalService.show(OrderBudgetModalComponent, {
        class: 'modal-lg',
        initialState: {
          modelObject: options.modelObject,
          moneyCurrency: _.cloneDeep(options.moneyCurrency),
          objTranslation: options.objTranslation,
          onComplete: complete
        }
      });
      modalRef.onHide?.subscribe(() => {
        complete({});
      });
    });
  }
}
